import React from "react";
import {useProposalOptionsQueryQuery} from "../../generated/graphql";
import {GraphQlSelect} from "./GraphQlSelect";

export const ProposalOptionSelect = (props) => {
    const query = useProposalOptionsQueryQuery();
    return <GraphQlSelect queryResult={query} {...props}  labelField="label" />;
}

